

export default {
    data() {
        return {
            modal: false,
        };
    },
    methods: {
        ouvre(next, plus) {
            this.next = next;
            this.modal = true;
            setTimeout(() => {
                const non = this.$refs.non;
                if (non) {
                    non.$el.focus();
                }
                if ("function" === typeof plus) {
                    plus();
                }
            });
        },
        confirme() {
            this.modal = false;
            this.next(this);
        },
        confirmeValeur(valeur) {
            this.modal = false;
            this.next(valeur);
        },
        ferme() {
            this.modal = false;
        },
    },
}
